import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _SignListFormat } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicMultiSelectTable } from "../../theme/Component/BasicMultiSelecTable";
import { Modal } from "../../theme/Component/Modal";

export interface SignListFormatMultiSelectResult {
    IDList: number[];
    ListItems: any[];
}

interface Props {
    label?: string;
    renderValue?: string;
    selectedItems?: any[];
    onChange: (value: SignListFormatMultiSelectResult | null) => void;
}

export const SignListFormatEditor = ({
    label,
    renderValue,
    selectedItems,
    onChange,
}: Props) => {

    const { lista, setLista, instance } = useDataBean(_SignListFormat);
    const [value, setValue] = useState(renderValue ?? "");
    const [selectedList, setSelectedList] = useState<any[]>(selectedItems ?? []);
    const [modal, setModal] = useState<any>({
        name: "Seleccionar plantillas de firmas",
        tabIndex: -1,
        view: false,
        btnClose: true,
        btnSubmit: true,
        format: "modal-lg",
    });

    const head = [
        { title: "ID", property: "IDSignListFormat", visible: true },
        { title: "Tipo de Firma", property: "RenderType", visible: true },
        { title: "Título del cargo", property: "JobTitle", visible: true },
        { title: "Nombre del Empleado", property: "AccountName", visible: true },
    ];

    const renderSignType = (signType: number) => {
        if (signType === 101) return "Firma Interna";
        if (signType === 102) return "Firma Externa";
        return "N/P";
    };

    const getList = () => {
        instance.getSignListFormatCatalogPorPropiedades({ State: 1 }, null)
            .then((response: any[]) => {
                const formattedList = (response ?? []).map((item: any) => ({
                    ...item,
                    DataBeanProperties: {
                        ...item.DataBeanProperties,
                        RenderType: renderSignType(item.DataBeanProperties?.SignType),
                    },
                }));
                setLista(formattedList);
            })
            .catch((error: any) => toast.error(error));
    };

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        setValue(renderValue ?? "");
    }, [renderValue]);

    useEffect(() => {
        setSelectedList(selectedItems ?? []);
    }, [selectedItems]);

    const returnData = () => {
        if (selectedList.length === 0) {
            setValue("");
            onChange(null);
            setModal((previous: any) => ({ ...previous, view: false }));
            return;
        }

        const items = selectedList.map(item => item.DataBeanProperties);
        const ids = items.map(item => item.IDSignListFormat);
        const names = items.map(item => item.AccountName || item.JobTitle).filter(Boolean);

        setValue(names.join(", "));
        onChange({ IDList: ids, ListItems: items });
        setModal((previous: any) => ({ ...previous, view: false }));
    };

    const clearSelection = () => {
        setValue("");
        setSelectedList([]);
        onChange(null);
    };

    return (
        <>
            <label>{label ?? "Plantillas de firmas"}</label>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ minHeight: "35px", cursor: "pointer" }}
                onClick={() => setModal(previous => ({ ...previous, view: true }))}
            >
                {value ? (
                    <>
                        <span>{value}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={(event) => {
                                event.stopPropagation();
                                clearSelection();
                            }}
                        >
                            ✕
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal}
                updateModal={setModal}
                eventModal={returnData}
            >
                <BasicMultiSelectTable
                    clearnotListBody
                    body={lista}
                    bodyResult={selectedList}
                    head={head}
                    keyId="IDSignListFormat"
                    updateValues={({ bodyResult }) => setSelectedList(bodyResult)}
                />
            </Modal>
        </>
    );
};
